import { Input } from '../input'
import InputValidators from 'utils/input-validators'
import { NotifyMeClient } from 'app/notify-me/client'
import i18next from 'i18next'

import './assets/notify-me.css'

import mailImage from './assets/mail@2x.png'

const SELECTOR = '.o-modal'
const MODAL_CONTAINER_SELECTOR = '.o-modal__container'
const FORM_BUTTON_SELECTOR = '.o-modal__button'
const SUCCESS_BUTTON = '.o-modal__button--success'
const CLOSE_BUTTON_SELECTOR = '.ic-close-16'

let modal, formButton
const body = document.querySelector('body')

let form = {
  postalCode: null,
  email: null,
  isValid: false,
}

const formModalContent = () => `
    <p class="o-modal__title">${i18next.t('notify_me_section.title')}</p>
    <p class="o-modal__text">${i18next.t('notify_me_section.text')}</p>
    <div class="o-modal__form">
      <div class="old-input-text" input-text-id="2"></div>
      <div class="old-input-text" input-text-id="3"></div>
    </div>
    <button disabled class="button o-modal__button">
      ${i18next.t('notify_me_section.button')}
    </button>`

const successSubscriptionModalContent = () => `
  <div class="o-modal__image-wrapper">
    <img class="o-modal__image" src=${mailImage}></img>
  </div>
  <p class="o-modal__title o-modal__title--success">${i18next.t(
    'notify_me_section.feedback.title',
  )}</p>
  <p class="o-modal__text o-modal__text--success">${i18next.t(
    'notify_me_section.feedback.subtitle',
  )}</p>
  <button class="button o-modal__button o-modal__button--success">${i18next.t(
    'notify_me_section.feedback.confirm',
  )}</button>`

const render = (modalContent) => {
  modal.innerHTML = `
    <div class="o-modal__container">
      <div class="o-modal__header">
        <i class="icon ic-close-16"></i>
      </div>
      <div class="o-modal__content">
        ${modalContent()}
      </div>
    </div>
  `
}

const renderModalInputs = () => {
  const postalCodeInput = new Input({
    textKey: 'notify_me_section.postal_code_input',
    ariaKey: 'notify_me_section.postal_code_input',
    id: 2,
    maxLength: 5,
    tooltipPosition: 'top',
    validator: InputValidators.postalCodeValidator,
    onInputCallback: onChange.bind(form, 'postalCode'),
    onKeyPressCallback: onKeyPress,
  })

  const emailInput = new Input({
    textKey: 'notify_me_section.email_input',
    ariaKey: 'notify_me_section.email_input',
    id: 3,
    maxLength: 150,
    tooltipPosition: 'bottom',
    validator: InputValidators.emailValidator,
    onInputCallback: onChange.bind(form, 'email'),
    onKeyPressCallback: onKeyPress,
  })

  postalCodeInput.mount()
  emailInput.mount()
}

const onChange = (formProperty, event) => {
  const { value } = event.target
  form[formProperty] = value
  validateForm()
}

const onKeyPress = (event) => {
  const isEnterKey = event.key === 'Enter'
  if (!isEnterKey) {
    return
  }
  onConfirmSubscription(event)
}

const validateForm = () => {
  const { postalCode, email } = form
  const isPostalCodeValid = !InputValidators.postalCodeValidator(postalCode)
  const isEmailValid = !InputValidators.emailValidator(email)

  form.isValid = isPostalCodeValid && isEmailValid

  formButton && updateButtonStatus(formButton)
}

const updateButtonStatus = (button) => {
  button.disabled = !form.isValid
}

const onModalClick = (event) => {
  const modalContainer = document.querySelector(MODAL_CONTAINER_SELECTOR)
  if (!modalContainer) {
    return
  }

  const isClickOutside = !modalContainer.contains(event.target)
  if (isClickOutside) {
    return removeModal()
  }
}

const removeModal = () => {
  clearFormValues()
  body.className = ''
  document.getElementsByTagName('body')[0].removeChild(modal)
}

const clearFormValues = () => {
  form = {
    isValid: false,
    postalCode: null,
    email: null,
  }
}

const addConfirmSubscriptionListener = () => {
  formButton = document.querySelector(FORM_BUTTON_SELECTOR)
  formButton.addEventListener('click', onConfirmSubscription)
}

const onConfirmSubscription = (event) => {
  event.stopPropagation()
  const { isValid, email, postalCode } = form

  if (!isValid) {
    return
  }

  renderNotifySuccessModal()
  NotifyMeClient.subscribe(email, postalCode)
}

export default function notifyMeAction() {
  body.className = 'block_scroll'
  modal = document.createElement('div')
  modal.className = 'o-modal'
  document.getElementsByTagName('body')[0].appendChild(modal)
  validateForm()
  render(formModalContent)
  renderModalInputs()
  addCloseButtonListener()
  addConfirmSubscriptionListener()
  addModalClickListener()
}

const addModalClickListener = () => {
  const _modal = document.querySelector(SELECTOR)
  _modal.addEventListener('click', onModalClick)
}

const renderNotifySuccessModal = () => {
  render(successSubscriptionModalContent)
  addCloseButtonListener()
  addSuccessButtonListener()
}

const addSuccessButtonListener = () => {
  const successButton = document.querySelector(SUCCESS_BUTTON)
  successButton.addEventListener('click', removeModal)
}

const addCloseButtonListener = () => {
  const closeButton = document.querySelector(CLOSE_BUTTON_SELECTOR)
  closeButton.addEventListener('click', removeModal)
}
